module.exports = __webpack_public_path__ + "static/media/visas12.046a1bec.PNG";